class CookieConsent {
  constructor() {
    this.initialize();
  }

  initialize() {
    CookieConsent.submitConsent = CookieConsent.submitConsent.bind(this);
    CookieConsent.submitAllConsent = CookieConsent.submitAllConsent.bind(this);
    CookieConsent.submitDeclineAllConsent = CookieConsent.submitDeclineAllConsent.bind(this);
    const detailLink = document.getElementById('elc-detail-link');

    if (detailLink) {
      if (detailLink.addEventListener) {
        detailLink.addEventListener('click', CookieConsent.toggleExpand);
      }
    }
    const hideDetailLink = document.getElementById('elc-hide-detail-link');
    if (hideDetailLink !== null) {
      if (hideDetailLink.addEventListener) {
        hideDetailLink.addEventListener('click', CookieConsent.toggleExpand);
      }
    }
    const saveLink = document.getElementById('elc-save-link');
    if (saveLink !== null) {
      if (saveLink.addEventListener) {
        saveLink.addEventListener('click', CookieConsent.submitConsent);
      }
    }
    const acceptLink = document.getElementById('elc-accept-link');
    if (acceptLink !== null) {
      if (acceptLink.addEventListener) {
        acceptLink.addEventListener('click', CookieConsent.submitConsent);
      }
    }
    const acceptAllLink = document.getElementById('elc-accept-all-link');
    if (acceptAllLink !== null) {
      if (acceptAllLink.addEventListener) {
        acceptAllLink.addEventListener('click', CookieConsent.submitAllConsent);
      }
    }
    const declineAllLink = document.getElementById('elc-decline-all-link');
    if (declineAllLink !== null) {
      if (declineAllLink.addEventListener) {
        declineAllLink.addEventListener('click', CookieConsent.submitDeclineAllConsent);
      }
    }
    const tabLink = document.getElementById('elc-tab-link');
    if (tabLink !== null) {
      if (tabLink.addEventListener) {
        tabLink.addEventListener('click', CookieConsent.toggleTab);
      }
    }
    CookieConsent.addWindowObject();
  }

  static submitConsent(event: Event) {
    event.preventDefault();
    const form = document.querySelector('#elc-cookie-consent-form') as HTMLFormElement;
    CookieConsent.submitData(form, false);
  }

  static submitDeclineAllConsent(event: Event) {
    event.preventDefault();
    const form = document.querySelector('#elc-cookie-consent-form') as HTMLFormElement;
    Array.from(form.elements).forEach((element) => {
      const field = element as HTMLInputElement;
      if (field.type === 'checkbox') {
        if (field.checked) {
          field.checked = false;
        }
      }
    });
    CookieConsent.submitData(form, false);
  }

  static submitAllConsent(event: Event) {
    event.preventDefault();
    const form = document.querySelector('#elc-cookie-consent-form') as HTMLFormElement;
    Array.from(form.elements).forEach((element) => {
      const field = element as HTMLInputElement;
      if (field.type === 'checkbox') {
        if (!field.checked) {
          field.checked = true;
        }
      }
    });
    CookieConsent.submitData(form, true);
  }

  static submitData(form: HTMLFormElement, submitAll: boolean) {
    const getSessionInfo = () => fetch('/actions/users/session-info', {
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => response.json());
    getSessionInfo().then((session) => {
      const data = CookieConsent.serialize(form);
      const cc = document.getElementById('elc-cookie-consent');
      const ccContainer = document.getElementById('elc-cookie-consent-container');
      const ccOverlay = document.getElementById('elc-cookie-overlay');
      const ccSuccess = document.getElementById('elc-cookie-consent-success');

      if (submitAll) {
        data.concat('&acceptAll=true');
      }

      if (ccOverlay && ccContainer && !ccContainer.classList.contains('on-page')) {
        ccContainer.classList.toggle('elc-hidden');
        ccOverlay.classList.toggle('elc-hidden');
        if (cc) {
          cc.classList.toggle('elc-hidden');
        }
        if (ccSuccess) {
          ccSuccess.classList.toggle('elc-hidden');
        }
      } else if (ccSuccess) {
        ccSuccess.classList.toggle('elc-hidden');
        setTimeout(() => ccSuccess.classList.toggle('elc-hidden'), 3000);
      }
      const cookieTab = document.getElementById('elc-cookie-tab');
      if (typeof cookieTab !== 'undefined' && cookieTab !== null) document.getElementById('elc-cookie-tab')?.classList.toggle('elc-hidden');

      const url = form.dataset.url || '/actions/cookie-consent/consent/update';

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
          'X-CSRF-Token': session.csrfTokenValue,
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: data,
      })
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          CookieConsent.addWindowObject();

          if (form.hasAttribute('data-refresh') && form.dataset.refresh === 'true' && form.hasAttribute('data-refreshtime')) {
            CookieConsent.refresh(parseInt(form.dataset.refreshtime ?? '0', 10));
          }
        })
        .catch((error) => {
          console.error('Consent submit error:', error);
        });
    });
  }

  static refresh(ms: number) {
    setTimeout(() => window.location.reload(), ms);
  }

  static toggleExpand(event: Event) {
    event.preventDefault();
    document.getElementById('elc-cookie-consent')?.classList.toggle('elc-fullwidth');
    document.getElementById('elc-cookie-consent')?.classList.toggle('elc-small');
  }

  static toggleTab(event: Event) {
    event.preventDefault();
    document.getElementById('elc-cookie-consent')?.classList.toggle('elc-hidden');
    document.getElementById('elc-cookie-consent-container')?.classList.toggle('elc-hidden');
    document.getElementById('elc-cookie-tab')?.classList.toggle('elc-hidden');
    document.getElementById('elc-cookie-consent')?.classList.add('elc-fullwidth');
    document.getElementById('elc-cookie-consent')?.classList.remove('elc-small');
  }

  static addWindowObject() {
    const form = document.querySelector('#elc-cookie-consent-form') as HTMLFormElement;
    if (form && typeof form.dataset.show !== 'undefined') {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', form.dataset.show);
      xhr.send();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          window.ccc = {};
          if (xhr.status === 200 && xhr.response !== 'null') {
            window.ccc = JSON.parse(xhr.response);
            window.runTracking();
          }
        }
      };
    }
  }

  /*!
   * Serialize all form data into a query string
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  static serialize(form: HTMLFormElement) {
    // Setup our serialized data
    const serialized: string[] = [];
    // Loop through each field in the form
    Array.from(form.elements).forEach((element) => {
      const field = element as HTMLInputElement;
      // Don't serialize fields without a name, submits,
      // buttons, file and reset inputs, and disabled fields
      if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'button') {
        // If a multi-select, get all selections
        if (field.type === 'select-multiple') {
          const selectField = element as HTMLSelectElement;
          Array.from(selectField.options).forEach((selectOption) => {
            if (selectOption.selected) {
              serialized.push(`${encodeURIComponent(selectField.name)}=${encodeURIComponent(selectOption.value)}`);
            }
          });
        } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) { // Convert field data to a query string
          serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
        }
      }
    });
    return serialized.join('&');
  }
}

export default CookieConsent;
